/* Hands of Atlas motion layer.
   Reveals, scroll-speed parallax, stat counters, hero drift.
   Material-3 timings, enter-decelerate, 60-90ms staggers.
   Fully disabled under prefers-reduced-motion. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) { document.documentElement.classList.add('hoa-motion-off'); return; }
  var mobile = window.matchMedia('(max-width: 749px)').matches;

  /* ---------- reveals ---------- */
  var groupSelectors = [
    '.product-card', '.collection-card__inner', '.hoa-styles__tile',
    '.hoa-split__panel'
  ];
  var singleSelectors = [
    'main h2', '.hoa-reviews__title'
  ];
  function tag(el, delay) {
    if (el.classList.contains('hoa-reveal')) return;
    el.classList.add('hoa-reveal');
    if (delay) el.style.transitionDelay = delay + 'ms';
  }
  groupSelectors.forEach(function (sel) {
    var els = document.querySelectorAll(sel);
    var perParent = {};
    els.forEach(function (el) {
      var p = el.parentElement ? (el.parentElement.className || 'x') : 'x';
      perParent[p] = (perParent[p] || 0);
      tag(el, Math.min(perParent[p] * 70, 420));
      perParent[p]++;
    });
  });
  singleSelectors.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) { tag(el, 0); });
  });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.hoa-reveal').forEach(function (el) { io.observe(el); });

  /* ---------- scroll-speed parallax ---------- */
  var plx = [];
  if (!mobile) {
    document.querySelectorAll(
      '.hoa-split__img, .hoa-edit__img, .hoa-cta__img, .hoa-pre__img, .hoa-foot__bg-img, [data-plx-speed] img'
    ).forEach(function (img) {
      var holder = img.closest('[data-plx-speed]');
      var speed = holder
        ? parseFloat(holder.getAttribute('data-plx-speed')) || 0.1
        : img.classList.contains('hoa-cta__img')
          ? 0.08
          : img.classList.contains('hoa-foot__bg-img')
            ? 0.06
            : 0.11;
      img.classList.add('hoa-plx');
      plx.push({ el: img, speed: speed });
    });
  }
  var ticking = false;
  function onScroll() {
    if (ticking || !plx.length) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      plx.forEach(function (p) {
        var r = p.el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var progress = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        p.el.style.setProperty('--plx', (progress * p.speed * -100).toFixed(1) + 'px');
      });
      ticking = false;
    });
  }
  if (plx.length) {
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- stat counters ---------- */
  var statEls = document.querySelectorAll('[id$="__stats"] h2, .hoa-stats__num');
  var cio = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      cio.unobserve(e.target);
      var target = parseInt(e.target.textContent.replace(/\D/g, ''), 10);
      if (!target || target > 100000) return;
      var t0 = null, dur = 900;
      function step(ts) {
        if (!t0) t0 = ts;
        var k = Math.min((ts - t0) / dur, 1);
        k = 1 - Math.pow(1 - k, 3); /* power3.out */
        e.target.textContent = Math.round(target * k);
        if (k < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.5 });
  statEls.forEach(function (el) { cio.observe(el); });

  /* ---------- hero drift ---------- */
  var heroImg = document.querySelector('[id$="__hero"] img');
  if (heroImg) heroImg.classList.add('hoa-hero-drift');
})();


/* hoaWarmHover: prefetch product-card hover images so hover never shows the color placeholder */
(function () {
  var warm = function () {
    document.querySelectorAll('.product-card img[loading="lazy"]').forEach(function (im, i) {
      setTimeout(function () {
        im.loading = 'eager';
        if (im.decode) im.decode().catch(function () {});
      }, 500 + i * 40);
    });
  };
  if (document.readyState === 'complete') setTimeout(warm, 500);
  else window.addEventListener('load', function () { setTimeout(warm, 500); });
})();


/* hoaSwatches: colored dots on Finish pills; survives picker re-renders and selection */
(function () {
  var MAP = {
    gold: 'linear-gradient(135deg,#E9C088,#C9973F)',
    silver: 'linear-gradient(135deg,#E8E8E8,#AFAFAF)',
    bronze: 'linear-gradient(135deg,#B07A42,#6B3E1A)',
    black: 'linear-gradient(135deg,#3A3A3A,#151515)'
  };
  function apply() {
    document.querySelectorAll('.variant-option__button-label, variant-picker label').forEach(function (l) {
      var t = l.textContent.trim().toLowerCase();
      if (MAP[t] && !l.querySelector('.hoa-swatch')) {
        var s = document.createElement('span');
        s.className = 'hoa-swatch';
        s.style.background = MAP[t];
        l.prepend(s);
      }
    });
  }
  apply();
  var swatchTimer;
  new MutationObserver(function () {
    clearTimeout(swatchTimer);
    swatchTimer = setTimeout(apply, 80);
  }).observe(document.body, { childList: true, subtree: true });
})();


/* hoaDrawerGuard: the drawer node survives checkout round-trips and the theme's
   page morphs (data-skip-node-update), and a bfcache restore drops the dialog's
   top-layer status, leaving it painted under the header with scroll locked.
   Close it through the theme-drawer component's own close() so its open attr,
   scroll lock, stack order and focus state all unwind together; raw
   dialog.close() desyncs the component and breaks the next open. */
(function () {
  function closeDrawer() {
    document.querySelectorAll('theme-drawer[open]').forEach(function (td) {
      if (typeof td.close === 'function') {
        try { td.close(); return; } catch (err) {}
      }
      var d = td.querySelector('dialog[open]');
      if (d) {
        try { d.close(); } catch (err) {}
        d.removeAttribute('open');
      }
      td.removeAttribute('open');
    });
  }
  window.addEventListener('pageshow', function (e) {
    var nav = (performance.getEntriesByType('navigation')[0] || {}).type;
    if (e.persisted || nav === 'back_forward') {
      var run = function () { closeDrawer(); };
      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('theme-drawer').then(run, run);
      } else { run(); }
    }
  });
  window.addEventListener('popstate', closeDrawer);
  var _push = history.pushState;
  history.pushState = function () {
    _push.apply(this, arguments);
    closeDrawer();
  };
})();


/* hoaCartExtras: cart refresh helpers used by the drawer.
   The shipping-protection toggle and the upsell rail it also drove were both
   removed at Ali's request; the listeners below now match nothing and are kept
   only because __hoaCartRefresh and __hoaCartPost are used elsewhere.
   Swap targets the real drawer (#shopify-section-cart-drawer-section > theme-drawer > dialog).
   Removals go through /cart/update.js keyed by variant id (change.js rejects variant ids). */
(function () {
  function refresh(sections) {
    if (!sections) return;
    var html = sections['cart-drawer-section'];
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('dialog');
    var cur = document.querySelector('#shopify-section-cart-drawer-section dialog') ||
              document.querySelector('#cart-drawer dialog');
    if (fresh && cur) {
      var wasOpen = cur.hasAttribute('open');
      cur.innerHTML = fresh.innerHTML;
      if (wasOpen && !cur.hasAttribute('open')) cur.setAttribute('open', '');
    }
    var freshBubble = doc.querySelector('.cart-bubble__text, [ref="cartBubbleText"]');
    if (freshBubble) {
      document.querySelectorAll('.cart-bubble__text, [ref="cartBubbleText"]').forEach(function (el) {
        el.textContent = freshBubble.textContent;
      });
    }
  }
  window.__hoaCartRefresh = refresh;
  function post(url, body) {
    body.sections = 'cart-drawer-section';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  window.__hoaCartPost = post;
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('[data-hoa-dot]');
    if (dot) {
      var item = dot.closest('.hoa-cx__item');
      item.querySelectorAll('[data-hoa-dot]').forEach(function (d) { d.classList.remove('is-on'); });
      dot.classList.add('is-on');
      var add = item.querySelector('[data-hoa-add]');
      if (add) add.setAttribute('data-variant', dot.getAttribute('data-variant'));
      return;
    }
    var btn = e.target.closest && e.target.closest('button[data-hoa-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Adding';
    var vid = parseInt(btn.getAttribute('data-variant'), 10);
    post('/cart/add.js', { id: vid, quantity: 1 })
      .then(function (d) {
        btn.textContent = 'Added';
        setTimeout(function () { refresh(d.sections); }, 300);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add';
      });
  }, true);
})();

/* hoaOrderTimeline: fills the PDP order-timeline strip with live dates and
   moves it directly above the buy buttons. Made to order 3-4 weeks, then
   5-9 working days tracked courier. */
(function () {
  function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  function init() {
    var tl = document.querySelector('[data-hoa-otl]:not([data-hoa-otl-done])');
    if (!tl) return;
    var now = new Date();
    function addD(n) { var d = new Date(now); d.setDate(d.getDate() + n); return d; }
    tl.querySelector('[data-hoa-otl-ordered]').textContent = fmt(now);
    tl.querySelector('[data-hoa-otl-production]').textContent = fmt(now) + ' to ' + fmt(addD(28));
    tl.querySelector('[data-hoa-otl-delivery]').textContent = fmt(addD(33)) + ' to ' + fmt(addD(40));
    var form = document.querySelector('.product-details product-form-component, .product-details add-to-cart-component, .product-details buy-buttons');
    if (form) {
      var anchor = form.closest('.group-block__item') || form;
      anchor.parentElement.insertBefore(tl, anchor);
    }
    tl.hidden = false;
    tl.setAttribute('data-hoa-otl-done', '1');
  }
  init();
  document.addEventListener('DOMContentLoaded', init);
  new MutationObserver(function () { init(); }).observe(document.body, { childList: true, subtree: true });
})();


/* hoaSavePill: computes the saving from sale vs compare-at price on the PDP
   and shows it as a small pill; follows variant/price re-renders. */
(function () {
  function money(el) {
    if (!el) return 0;
    var m = el.textContent.replace(/[^0-9.]/g, '');
    return parseFloat(m) || 0;
  }
  function apply() {
    var details = document.querySelector('.product-details');
    if (!details) return;
    var compare = details.querySelector('.compare-at-price');
    var sale = details.querySelector('.price-item__group.price');
    var old = details.querySelector('.hoa-save');
    if (!compare || !sale) { if (old) old.remove(); return; }
    /* The pill itself is rendered by snippets/price.liquid in the visitor's
       currency (a JS "$" + parsed digits broke in EUR/SEK). Here we only make
       sure it sits right after the compare-at price. */
    if (old && old.previousElementSibling !== compare) compare.after(old);
  }
  apply();
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(apply, 120);
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();


/* hoaFlair: moves the sale ribbon + stars row under the PDP title, fills the
   live percent from the price pair, and anchors the stars to the reviews. */
(function () {
  function money(el) {
    if (!el) return 0;
    return parseFloat(el.textContent.replace(/[^0-9.]/g, '')) || 0;
  }
  function apply() {
    var flair = document.querySelector('[data-hoa-flair]');
    if (!flair) return;
    var details = document.querySelector('.product-details');
    if (!details) return;
    if (flair.hidden) {
      var h1 = details.querySelector('h1');
      if (h1) {
        var anchor = h1.closest('.group-block__item') || h1;
        anchor.after(flair);
      }
      flair.hidden = false;
      var stars = flair.querySelector('[data-hoa-flair-stars]');
      if (stars) {
        stars.addEventListener('click', function (e) {
          var target = document.querySelector('[id$="__hoa_testimonials"], [id$="__hoa_reviews"]');
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    }
    var off = flair.querySelector('[data-hoa-flair-off]');
    var offerRow = flair.querySelector('.hoa-flair__offer');
    var pill = details.querySelector('[data-hoa-save]');
    var pct = pill ? parseInt(pill.getAttribute('data-hoa-pct'), 10) : 0;
    if (!pct) {
      var c = money(details.querySelector('.compare-at-price'));
      var s = money(details.querySelector('.price-item__group.price'));
      if (c > s && s > 0) pct = Math.round((1 - s / c) * 100);
    }
    if (pct > 0) {
      off.textContent = pct + '% off';
      offerRow.style.display = '';
    } else if (offerRow) {
      offerRow.style.display = 'none';
    }
  }
  apply();
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(apply, 140);
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();


/* hoaLightSwitch: the "Light" toggle on collection pages. Cross-fades every
   card between its unlit and lit photograph and warms the page ground, so
   flipping it reads as the lamps coming on in the room.
   Choice persists per browser.

   The state lives on <html> and is scoped to pages that actually carry the
   paired card images. The theme morphs between pages without a reload, so
   leaving the attribute (or the ground layer) behind would repaint every
   other page's sections. Both are torn down whenever the grid is absent. */
(function () {
  var KEY = 'hoaLight';
  function state() {
    try { return localStorage.getItem(KEY) === 'on' ? 'on' : 'off'; } catch (e) { return 'off'; }
  }
  function hasGrid() {
    /* the switch only renders on collection templates. Gating on the card
       pairs alone would fire on product pages too, whose recommendation rows
       carry the same pairs and load in late. */
    return !!document.querySelector('[data-hoa-lsw]') && !!document.querySelector('.hoa-lite');
  }
  function ground() {
    var g = document.getElementById('hoa-ground');
    if (!g && document.body) {
      g = document.createElement('div');
      g.id = 'hoa-ground';
      g.setAttribute('aria-hidden', 'true');
      document.body.insertBefore(g, document.body.firstChild);
    }
    return g;
  }
  function teardown() {
    document.documentElement.removeAttribute('data-hoa-light');
    var g = document.getElementById('hoa-ground');
    if (g && g.parentNode) g.parentNode.removeChild(g);
  }
  function paint(v) {
    document.documentElement.setAttribute('data-hoa-light', v);
    ground();
    try { localStorage.setItem(KEY, v); } catch (e) {}
  }
  /* the lit layer is lazy by default; once the lamps are on it must paint
     without waiting for a scroll, or cards read as empty */
  function eagerLit() {
    document.querySelectorAll('.hoa-lite__img--on[loading="lazy"]').forEach(function (i) {
      i.loading = 'eager';
    });
  }
  function markRoom() {
    var grid = document.querySelector('.hoa-lite');
    if (!grid) return;
    var main = grid.closest('[id$="__main"]') || grid.closest('.shopify-section');
    if (main) main.classList.add('hoa-lite-room');
  }
  function shown(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  /* the desktop toolbar row is display:none on phones, so a host has to be
     picked by what is actually visible, not by which selector exists */
  function place(sw) {
    if (!sw) return;
    if (sw.getAttribute('data-hoa-placed') && shown(sw)) return;
    var hosts = [
      document.querySelector('.facets-mobile-wrapper'),
      document.querySelector('.facets-toggle__wrapper'),
      document.querySelector('.products-count-wrapper'),
    ];
    for (var i = 0; i < hosts.length; i++) {
      var bar = hosts[i];
      if (!shown(bar)) continue;
      var host = bar.parentElement || bar;
      if (!shown(host)) host = bar;
      host.appendChild(sw);
      host.style.alignItems = 'center';
      sw.setAttribute('data-hoa-placed', '1');
      if (shown(sw)) return;
    }
  }

  /* the category and style links live in the desktop sidebar, which is hidden
     on phones, so mirror them into the mobile filter drawer */
  function mirrorNav() {
    var drawer = document.getElementById('filters-drawer');
    if (!drawer || drawer.querySelector('.hoa-snav')) return;
    var nav = document.querySelector('.facets--vertical .hoa-snav');
    if (!nav) return;
    var host = drawer.querySelector('.facets__filters-wrapper') || drawer.querySelector('.facets__form');
    if (!host) return;
    var clone = nav.cloneNode(true);
    clone.classList.add('hoa-snav--drawer');
    host.insertBefore(clone, host.firstChild);
  }
  function init() {
    if (!hasGrid()) { teardown(); return; }
    markRoom();
    mirrorNav();
    var sw = document.querySelector('[data-hoa-lsw]');
    if (!sw) { teardown(); return; }
    place(sw);
    var input = sw.querySelector('[data-hoa-light-input]');
    if (!input) return;
    var v = state();
    paint(v);
    input.checked = v === 'on';
    if (v === 'on') eagerLit();
    if (input.getAttribute('data-hoa-bound')) return;
    input.setAttribute('data-hoa-bound', '1');
    input.addEventListener('change', function () {
      var nv = input.checked ? 'on' : 'off';
      if (nv === 'on') eagerLit();
      paint(nv);
    });
  }
  init();
  document.addEventListener('DOMContentLoaded', init);
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(init, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


/* hoaStickyOptions: the sticky buy bar showed the variant as a run-on text line
   ("H 80 x W 30 cm / Gold") which wrapped into a broken column on phones.
   Replace it with real selects that drive the page's own variant radios, so
   the theme keeps owning variant state and we only mirror it. */
(function () {
  function optionGroups() {
    var out = [];
    document.querySelectorAll('.product-details fieldset').forEach(function (fs) {
      var radios = fs.querySelectorAll('input[type="radio"]');
      if (!radios.length) return;
      var legend = fs.querySelector('legend, .variant-option__label, label');
      var name = legend ? legend.textContent.trim().split('\n')[0].trim() : '';
      out.push({ name: name, radios: radios });
    });
    return out;
  }

  function build() {
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!bar) return;
    var info = bar.querySelector('.sticky-add-to-cart__info');
    var line = bar.querySelector('.sticky-add-to-cart__variant');
    if (!info) return;

    var groups = optionGroups();
    if (!groups.length) return;

    var host = bar.querySelector('.hoa-sticky-opts');
    if (host && host.getAttribute('data-count') === String(groups.length)) {
      /* already built: just resync the selected values */
      groups.forEach(function (g, i) {
        var sel = host.querySelectorAll('select')[i];
        if (!sel) return;
        g.radios.forEach(function (r) { if (r.checked) sel.value = r.value; });
      });
      return;
    }

    if (host) host.remove();
    host = document.createElement('div');
    host.className = 'hoa-sticky-opts';
    host.setAttribute('data-count', String(groups.length));

    groups.forEach(function (g) {
      var sel = document.createElement('select');
      sel.setAttribute('aria-label', g.name || 'Option');
      g.radios.forEach(function (r) {
        var o = document.createElement('option');
        o.value = r.value;
        o.textContent = r.value;
        if (r.disabled) o.disabled = true;
        if (r.checked) o.selected = true;
        sel.appendChild(o);
      });
      sel.addEventListener('change', function () {
        for (var i = 0; i < g.radios.length; i++) {
          if (g.radios[i].value === sel.value) {
            /* click the page's own control so the theme updates price,
               image and the add button exactly as it normally would */
            g.radios[i].click();
            break;
          }
        }
      });
      host.appendChild(sel);
    });

    if (line) line.replaceWith(host);
    else info.appendChild(host);
  }

  build();
  document.addEventListener('DOMContentLoaded', build);
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(build, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
